import Topbar from "./components/topbar/Topbar";
import Intro from "./components/intro/Intro";
import Portfolio from "./components/portfolio/Portfolio";
import Works from "./components/works/Works";
import Testimonials from "./components/testimonials/Testimonials";
import Contact from "./components/contact/Contact";
import ProjectDetails from "./components/ProjectDetails/ProjectDetails";
import "./app.scss";
import { useState } from "react";
import Menu from "./components/menu/Menu";
import { Switch, Route } from "react-router-dom";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="app">
      <Topbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <Switch>
        <Route path="/details/:id">
          <ProjectDetails />
        </Route>

        <Route path="/">
          <div className="sections">
            <Intro />
            <Portfolio />
            <Works />
            <Testimonials />
            <Contact />
          </div>
        </Route>
      </Switch>
    </div>
  );
}

export default App;
